import NiceSelect from "nice-select2/dist/js/nice-select2";
if (document.querySelector(".woocommerce-ordering .orderby"))
  new NiceSelect(document.querySelector(".woocommerce-ordering .orderby"), {});
